export function invariant(): never {
  throw new Error('Invariant failed')
}
